import { ChangeDetectionStrategy, Component, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { A11yModule } from "@angular/cdk/a11y";
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { EventModel } from '../../../models/api/EventModel';
import { EventService } from '../../../services/api/EventService';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { EventStatusService } from '../../../services/api/EventStatusService';
import { EventStatusModel } from '../../../models/api/EventStatusModel';
import { forkJoin } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { EventDetailsComponent } from '../event-details/event-details.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-all-events',
  standalone: true,
  imports: [
    A11yModule,
    MatTableModule,
    MatIconModule,
    MatTooltipModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    DatePipe,
    MatDialogModule,
    RouterModule,
  ],
  templateUrl: './all-events.component.html',
  styleUrl: './all-events.component.scss'
})
export class AllEventsComponent implements OnInit {

  eventStatuses: EventStatusModel[] = [];
  public eventStatus: number = 0;
  public activeEventID: number = 0;
  public isLoaded: boolean = false;
  readonly dialog = inject(MatDialog);

  isSidenavOpen = false;

  events: EventModel[] = [];
  eventsTemp: EventModel[] = [];

  displayedColumns: string[] = ['eventName', 'venueName', 'city', 'country', 'startDate', 'endDate', 'eventStatusID', 'actions'];
  dataSource = new MatTableDataSource<EventModel>();

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private eventService: EventService,
    private snackbar: MatSnackBar,
    private eventStatusService: EventStatusService,
    private dialogService: MatDialog,
    private router: Router,
  ) {

  }
  ngOnInit(): void {
    this.getEvents();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filterTable(eventStatusID: number) {
    this.eventsTemp = this.events;

    if (eventStatusID > 0) {
      this.eventsTemp = this.eventsTemp.filter(t => t.eventStatusID === eventStatusID);
    }
    this.dataSource.data = this.eventsTemp;
  }


  getEvents() {
    forkJoin({
      statuses: this.eventStatusService.findEventStatus(),
      events: this.eventService.findEvent()
    }).subscribe({
      next: ({ statuses, events }) => {
        this.eventStatuses = statuses.data as EventStatusModel[];
        const eventData = events.data as EventModel[];
        this.events = eventData;
        this.dataSource.data = eventData;
        this.dataSource.sort = this.sort;
        this.isLoaded = true;
      },
      error: (err) => {
        console.error('API error:', err);
      }
    });
  }

  getEventStatus(eventStatusID: number) {
    return this.eventStatuses.find(x => (x.eventStatusID === eventStatusID))?.statusName;
  }


  editEvent(eventID: number) {
    const editDialog = this.dialogService.open(EventDetailsComponent, {
      disableClose: true,
      data: { eventID: eventID },
      panelClass: 'wh-form-dialog',
      width: '600px',
        })

    editDialog.afterClosed().subscribe(response => {
      this.getEvents();
    })
  }

  deleteEvent(eventID: number, eventName: string) {

    const deleteDialog = this.dialog.open(EventDeleteDialog, {
      data: {
        eventName: eventName,
        eventID: eventID,
      },
      panelClass: 'delete-dialog',
    });

    deleteDialog.afterClosed().subscribe(result => {
      if (result) {
        if (eventID) {

          this.eventService.deleteEvent(eventID).subscribe({
            next: (data) => {
              this.snackbar.open("EVENT DELETED", "CLOSE", {
                panelClass: "confirm-snackbar",
              });
              this.getEvents();
            },
            error: (err) => {
              console.error('Error deleting event:', err);
            }
          })
        }
      } else {
      }
    })

  }

  addEvent() {
    const addDialog = this.dialogService.open(EventDetailsComponent, {
      disableClose: true,
      panelClass: 'wh-form-dialog',
      width: '600px'
    })

    addDialog.afterClosed().subscribe(response => {
      this.getEvents();
    })
  }


  goToEventDashboard(eventID: number) {
    this.router.navigate(['/admin/events/', eventID]);
  }
}


@Component({
  selector: 'event-delete-dialog',
  templateUrl: 'event-delete-dialog.html',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventDeleteDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { eventID: number, eventName: string }) { }

  readonly dialogRef = inject(MatDialogRef<EventDeleteDialog>);
}